<input [value]="searchValue"  [required]="isInput"  (click)="restoreSearch()" (keyup)="searchAddress($event)" class="form-control pac-target-input w-100" placeholder="Cerca un indirizzo" [(ngModel)]="search"  />
<div class="list-group" *ngIf="search">
  <button  *ngFor="let prediction of predictions" class="list-group-item list-group-item-action"
    (click)="exportAddress(prediction)">
    {{prediction.description}}
  </button>
</div>
